import Config from '../Config';
import Services from './services';

const SynergyModel = {
    remote_getAll: (providerId, getAll) => {
        return Services.getApi(Config.getBasePath() + `/providers/${providerId}/synergy/task-codes?all=${getAll}`);
    },
    remote_re_get_all: (providerId) => {
        return Services.deleteApi( Config.getBasePath() + `/providers/${providerId}/synergy/task-codes`,
        );
    },
    remote_editOne: (providerId, taskCode) => {
        return Services.putApi(Config.getBasePath() + `/providers/${providerId}/synergy/task-codes/${taskCode}/enabled`);

    },
}

export default SynergyModel